export default __webpack_public_path__ + "static/media/Ostali 10.2c02f012.jpg";